'use strict'

import {
	RECEIVE_DETAIL_STATION,
	RECEIVE_DETAIL_QUALITO,
	RECEIVE_DETAIL_PICKUP_OPERATION,
	RECEIVE_DETAIL_PIEZOMETER_MEASURE,
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX,
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN,
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE,
	RECEIVE_DETAIL_STATION_NETWORK,
	RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT,
	ADD_QUALITOMETER_DETAIL_ANALYSIS,
	ADD_PARAMETERS,
	ADD_UNITS,
	DETAIL_STATION_RESET,
	ADD_REMARKS,
	ADD_SUPPORTS,
	RECEIVE_INDUSTRIAL_SEVESO,
	RECEIVE_INDUSTRIAL_FAMILY,
	RECEIVE_INDUSTRIAL_ACTIVITY,
	RECEIVE_DETAIL_INDUSTRIAL,
	RECEIVE_DETAIL_POLLUTED_SOIL,
	RECEIVE_ICPE_ACTIVITY
} from '../constants/DetailStationConstants'
import DtoDetailPiezometerMeasure from '../dto/DtoDetailPiezometerMeasure'
import DtoDetailStationNetwork from '../dto/DtoDetailStationNetwork'
import DtoDetailStationSamplingSurfacePoint from '../dto/DtoDetailStationSamplingSurfacePoint'
import DtoDetailStation from '../dto/DtoDetailStation'
import DtoPickupOperation from '../dto/DtoPickupOperation'
import { uniqWith } from 'lodash'
import DtoAnalysis from '../dto/DtoAnalysis'
import DtoParameter from '../../referential/dto/DtoParameter'
import DtoUnit from '../../referential/dto/DtoUnit'
import DtoRemark from '../../referential/dto/DtoRemark'
import DtoSupport from '../../referential/dto/DtoSupport'
import DtoIndustrialSite from '../dto/DtoIndustrialSite'
import DtoIndustrialActivity from '../dto/DtoIndustrialActivity'
import DtoIndustrialSeveso from '../dto/DtoIndustrialSeveso'
import DtoIndustrialFamily from '../dto/DtoIndustrialFamily'
import DtoIcpeActivity from '../dto/DtoIcpeActivity'
import DtoPollutedSoil from '../dto/DtoPollutedSoil'


export const store = {
	station: {
		site: {
			name: '',
			comment: '',
			localization: {
				xCoordinate: '',
				yCoordinate: ''
			},
			address: {
				address: '',
				complement: '',
				localizationName: ''
			}
		},
		hydrologicArea: {
			name: '',
			code: ''
		},
		waterMass: {
			name: '',
			code: ''
		}
	},
	pickupOperations: [],
	analysis: [],
	piezometerMeasures: [],
	piezometerMeasuresMax: [],
	piezometerMeasuresMin: [],
	piezometerMeasuresMoyenne: [],
	networks: [],
	samplingSurfacePoints: [],
	parameters: [],
	units: [],
	remarks: [],
	supports: [],
	industrialFamily: [],
	industrialActivity: [],
	industrialSeveso: [],
	industrialSite: [],
	pollutedSoil: {},
	icpeActivity: []
}

export function DetailStationReducer(state = {}, action) {
	switch (action.type) {
		case RECEIVE_DETAIL_STATION: {
			return Object.assign({}, state, {
				station: new DtoDetailStation(action.station)
			})
		}
		case RECEIVE_DETAIL_QUALITO: {
			return Object.assign({}, state, {
				station: new DtoDetailStation(action.station)
			})
		}
		case RECEIVE_DETAIL_PICKUP_OPERATION: {
			return Object.assign({}, state, {
				pickupOperations: uniqWith([].concat(action.pickupOperations.map(el => new DtoPickupOperation(el)), state.pickupOperations), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case RECEIVE_DETAIL_PIEZOMETER_MEASURE: {
			return Object.assign({}, state, {
				piezometerMeasures: action.measures.map(el => new DtoDetailPiezometerMeasure(el))
			})
		}
		case RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX: {
			return Object.assign({}, state, {
				piezometerMeasuresMax: action.measures.map(el => new DtoDetailPiezometerMeasure(el))
			})
		}
		case RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN: {
			return Object.assign({}, state, {
				piezometerMeasuresMin: action.measures.map(el => new DtoDetailPiezometerMeasure(el))
			})
		}
		case RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE: {
			return Object.assign({}, state, {
				piezometerMeasuresMoyenne: action.measures.map(el => new DtoDetailPiezometerMeasure(el))
			})
		}
		case RECEIVE_DETAIL_STATION_NETWORK: {
			return Object.assign({}, state, {
				networks: uniqWith([].concat(action.networks.map(el => new DtoDetailStationNetwork(el)), state.networks), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT: {
			return Object.assign({}, state, {
				samplingSurfacePoints: uniqWith([].concat(action.samplingSurfacePoints.map(el => new DtoDetailStationSamplingSurfacePoint(el)), state.samplingSurfacePoints), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case ADD_QUALITOMETER_DETAIL_ANALYSIS: {
			return Object.assign({}, state, {
				analysis: uniqWith([].concat(action.analysis.map(el => new DtoAnalysis(el)), state.analysis), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case ADD_PARAMETERS: {
			return Object.assign({}, state, {
				parameters: uniqWith([].concat(action.parameters.map(el => new DtoParameter(el)), state.parameters), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case ADD_UNITS: {
			return Object.assign({}, state, {
				units: uniqWith([].concat(action.units.map(el => new DtoUnit(el)), state.units), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case ADD_REMARKS: {
			return Object.assign({}, state, {
				remarks: uniqWith([].concat(action.remarks.map(el => new DtoRemark(el)), state.remarks), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case ADD_SUPPORTS: {
			return Object.assign({}, state, {
				supports: uniqWith([].concat(action.supports.map(el => new DtoSupport(el)), state.supports), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case RECEIVE_DETAIL_INDUSTRIAL: {
			return Object.assign({}, state, {
				industrialSite: new DtoIndustrialSite(action.industrialSite)
			})
		}
		case RECEIVE_INDUSTRIAL_ACTIVITY: {
			return Object.assign({}, state, {
				industrialActivity: uniqWith([].concat(action.industrialActivity.map(el => new DtoIndustrialActivity(el)), state.industrialActivity), (a, b) => {
					return a.type === b.type && a.code === b.code
				})
			})
		}
		case RECEIVE_INDUSTRIAL_SEVESO: {
			return Object.assign({}, state, {
				industrialSeveso: uniqWith([].concat(action.industrialSeveso.map(el => new DtoIndustrialSeveso(el)), state.industrialSeveso), (a, b) => {
					return a.type === b.type && a.code === b.code
				})
			})
		}
		case RECEIVE_INDUSTRIAL_FAMILY: {
			return Object.assign({}, state, {
				industrialFamily: uniqWith([].concat(action.industrialFamily.map(el => new DtoIndustrialFamily(el)), state.industrialFamily), (a, b) => {
					return a.type === b.type && a.code === b.code
				})
			})
		}
		case RECEIVE_ICPE_ACTIVITY: {
			return Object.assign({}, state, {
				icpeActivity: uniqWith([].concat(action.icpeActivity.map(el => new DtoIcpeActivity(el)), state.icpeActivity), (a, b) => {
					return a.type === b.type && a.code === b.code
				})
			})
		}
		case RECEIVE_DETAIL_POLLUTED_SOIL: {
			return Object.assign({}, state, {
				pollutedSoil: new DtoPollutedSoil(action.pollutedSoil)
			})
		}
		case DETAIL_STATION_RESET: {
			return Object.assign({}, state, store)
		}
		default:
			return state
	}
}




// WEBPACK FOOTER //
// ./src/station/reducers/DetailStationReducer.js